import { useSelector } from 'react-redux';
import { Choices } from 'components/Filter/themes/BGH-RD3/types/choices';
import { Filter } from 'components/Filter/themes/BGH-RD3/mobile/filter';
import { Sort } from 'components/Filter/themes/BGH-RD3/mobile/sort';
import { getShowingAmountCaption } from 'components/Filter/themes/BGH-RD3/types';
import { nbrOfHitsSelector } from 'components/Filter/selector';
import { Section } from 'components/Section';
import styles from './filterMobile.scss';
import { forwardRef, Ref } from 'react';

export const FilterMobile = forwardRef((_, ref: Ref<HTMLDivElement>) => {
  const nbrOfHits = useSelector(nbrOfHitsSelector);

  const showingAmountCaption = getShowingAmountCaption(nbrOfHits);

  return (
    <div className={styles.filterMobile} ref={ref}>
      <Section className={styles.section} full>
        <div className={styles.buttons}>
          <div className={styles.nbrOfHits}>{showingAmountCaption}</div>
          <div>
            <Filter className={styles.filterButton} />
            <Sort className={styles.sortButton} />
          </div>
        </div>
        <Choices />
      </Section>
    </div>
  );
});
